/**
 * Constants for user-facing messages in the React frontend.
 */

// User-facing Messages
export const CHATBOT_WELCOME_MESSAGE = "Willkommen beim Lohmann & Rauscher UC2 Chatbot! Erzählen Sie mir von Ihrem Problem und chatten Sie mit mir - je mehr Details Sie mir geben, desto besser kann ich Ihnen helfen.";